module.exports = __webpack_public_path__ + "static/class-warfare-c602142de520c62e6a38991596909616.jpg";